import React, { useState, useEffect, useContext } from 'react'
import usePortal from 'react-useportal'
import styled from 'styled-components'
import { GetSubscriptionPlans } from '../../../../../store/ContentfulClient'

import { CancelSubscription, GetSubscription } from '../../../../../store/SubscriptionClient'
import IpsaContext from '../../../../../context/IpsaContext'
import DisplayPlans from './DisplayPlans'
import StripePortalButton from '../../../components/StripePortalButton'
import CancelModal from './CancelModal'

const UpdateActiveSubscription = () => {
    const [subscriptionPlans, setSubscriptionPlans] = useState([])
    const [selectedPlan, setSelectedPlan] = useState({
        val: '',
        name: '',
        price: '',
        stripeDiscountCouponCode: '',
    })
    const [subscriptionInfo, setSubscriptionInfo] = useState({})

    const {
        openPortal: openCancelPortal,
        closePortal: closeCancelPortal,
        isOpen: cancelPortalIsOpen,
        Portal: CancelPortal,
    } = usePortal({
        bindTo: document && document.getElementById('modal-portal'),
        onOpen({ portal }) {
            portal.current.style.cssText = `
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            z-index: 1000;
            `
        },
    })

    const {
        subscription: { status, level, planId },
        refreshUser,
    } = useContext(IpsaContext)

    const CancelButton = styled.button`
        border: none;
        background: transparent;
        padding: 0;
    `

    useEffect(() => {
        GetSubscription().then((sub) => {
            setSubscriptionInfo(sub.data)
        })
    }, [])

    useEffect(() => {
        GetSubscriptionPlans().then((plans) => {
            setSubscriptionPlans(plans)
        })
    }, [])

    useEffect(() => {
        const selectedPlan = subscriptionPlans.filter(
            (plan) => plan.fields.stripePlanId === planId
        )[0]

        if (selectedPlan) {
            setSelectedPlan(selectedPlan.fields)
        } else {
            console.error('No plan found')
        }
    }, [subscriptionPlans, planId])

    const cancelSubscription = async () => {
        closeCancelPortal()
        CancelSubscription().then(() => {
            refreshUser().then((_) => {
                GetSubscription().then((sub) => {
                    setSubscriptionInfo(sub.data)
                })
            })
        })
    }

    const {
        status: stripestatus,
        currentPeriodEnd,
        cancelAt,
        cancelAtPeriodEnd,
        paymentSetup,
        paymentAmount,
        paymentOriginalAmount,
        couponName,
        trialStart,
        trialEnd,
    } = subscriptionInfo

    return (
        <>
            <div className="checkout">
                {cancelPortalIsOpen && (
                    <CancelPortal className="class-here">
                        <CancelModal
                            onClose={closeCancelPortal}
                            onConfirm={cancelSubscription}
                            date={currentPeriodEnd}
                        ></CancelModal>
                    </CancelPortal>
                )}
                <h1>Subscription Details</h1>
                <div className="checkout-container">
                    <div>
                        <p>
                            <b>Subscription Status :</b> {status}
                        </p>
                        <p>
                            <b>Subscription Level :</b>{' '}
                            {level && level.length > 5 ? level.substring(4, level.length) : level}
                        </p>
                        <p>
                            <b>Payment Setup : </b>
                            {paymentSetup}
                        </p>
                        {!couponName && (
                            <p>
                                <b>Payment Amount:</b> ${paymentAmount}
                            </p>
                        )}
                        {couponName && (
                            <>
                                <p>
                                    <b>Payment Amount :</b>{' '}
                                    <span style={{ textDecoration: 'line-through' }}>
                                        ${paymentOriginalAmount}
                                    </span>
                                    <span> ${paymentAmount}</span>
                                </p>
                                <p>
                                    <b>Coupon Applied:</b> {couponName}
                                </p>
                            </>
                        )}
                        {status === 'Trialing' && (
                            <>
                                <p>
                                    <b>Trial Start :</b> {trialStart}
                                </p>
                                <p>
                                    <b>Trial End :</b> {trialEnd}
                                </p>
                            </>
                        )}
                        {cancelAtPeriodEnd === 'Yes' ? (
                            <p>
                                <b>Cancelling on :</b> {cancelAt}
                            </p>
                        ) : (
                            <>
                                <p>
                                    <b>Next Billing date:</b> {currentPeriodEnd}
                                </p>
                                <CancelButton onClick={openCancelPortal}>
                                    Cancel subscription
                                </CancelButton>
                            </>
                        )}
                        {paymentSetup === 'Yes' && (
                            <div style={{ marginTop: '25px' }}>
                                <StripePortalButton />
                            </div>
                        )}
                    </div>
                    <div className="checkout checkout-lg">
                        <DisplayPlans
                            selectedPlan={selectedPlan}
                            onPlanChanged={(val, name, price, stripeDiscountCouponCode) => {
                                setSelectedPlan({
                                    val,
                                    name,
                                    price,
                                    stripeDiscountCouponCode,
                                })
                            }}
                            paymentSetup={selectedPlan && paymentSetup === 'Yes'}
                            goodStanding={
                                status.toLowerCase() !== 'incomplete' &&
                                status.toLowerCase() !== 'pastdue'
                            }
                            discountPriceActive={couponName ? paymentAmount : null}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateActiveSubscription
